import { render, staticRenderFns } from "./FeedBack.vue?vue&type=template&id=42615ffc&"
import script from "./FeedBack.vue?vue&type=script&lang=js&"
export * from "./FeedBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports